import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { AnalyzeReportManagerModel } from "src/app/models/analyze-report-manager-model";
import { STORAGE_KEY_UUID_MANAGER } from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";

import { MatTableDataSource } from "@angular/material/table";
import { PageEvent } from "@angular/material/paginator";
import { AnalyzeReportManagerModelPaginated } from "src/app/models/analyze-report-manager-model-paginated";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";

import { AnalyzeTripService } from "src/app/services/analyze-trip.service";
import { MinioService } from "src/app/services/minio.service";
import { PermissionsService } from "src/app/helpers/permissions.service";

@Component({
  selector: "app-manager-analysis",
  templateUrl: "./manager-analysis.component.html",
  styleUrls: ["./manager-analysis.component.scss"],
})
export class ManagerAnalysisComponent implements OnInit, OnDestroy {
  public analyzeTripService: AnalyzeTripService;
  public minioService: MinioService;
  public datePipe: DatePipe;
  public spinner: NgxSpinnerService;

  public analyzeReportManagerModelsPaginated: AnalyzeReportManagerModelPaginated;
  public analyzeReportOperatorModel: AnalyzeReportManagerModel;
  public errorMessage;
  public analyzeReportManagersPage: AnalyzeReportManagerModelPaginated;
  public analyzesManagers: MatTableDataSource<any> =
    new MatTableDataSource<any>();
  public tableColumns: string[];
  public typeFieldSelect = [
    { name: "Número Pacote", value: "PACKAGE" },
    { name: "Motorista", value: "DRIVER" },
    { name: "Placa", value: "PLATE" },
    { name: "Base Opera.", value: "BASE" },
    { name: "Nome Operador", value: "OPERATOR" },
  ];

  public typeFieldFilterSelected;
  public actualPage: PageEvent;
  public permissions: [];
  public filter = "";
  public field = "";
  public packageNumber = "";
  private intervalId: any;
  private filterSearch$ = new Subject<string>();
  private filterSearchSubscription: Subscription;
  private readonly filterDebounceMs = 400;

  constructor(
    datePipe: DatePipe,
    spinner: NgxSpinnerService,
    public router: Router,
    analyzeTripService: AnalyzeTripService,
    minioService: MinioService,
    public permissionService: PermissionsService
  ) {
    this.datePipe = datePipe;
    this.analyzeTripService = analyzeTripService;
    this.minioService = minioService;
    this.spinner = spinner;
  }

  ngOnInit(): void {
    this.permissions = this.permissionService.getPermissions();
    this.typeFieldFilterSelected = this.typeFieldSelect[0].value;
    this.field = this.typeFieldFilterSelected;
    this.initialPage();
    this.setupFilterDebounce();
    this.loadReports(this.actualPage, this.filter, this.field);
    this.loadTableDefinitions();
    //this.startCallingLoadReports();
  }

  private setupFilterDebounce(): void {
    this.filterSearchSubscription = this.filterSearch$
      .pipe(debounceTime(this.filterDebounceMs), distinctUntilChanged())
      .subscribe(() => {
        this.actualPage.pageIndex = 0;
        this.loadReports(this.actualPage, this.filter, this.field, true);
      });
  }

  ngOnDestroy(): void {
    this.stopCallingLoadReports();
    this.filterSearchSubscription?.unsubscribe();
    this.filterSearch$.complete();
    this.spinner.hide();
  }

  // private startCallingLoadReports(): void {
  //   console.log("Data atual:", new Date());
  //   this.intervalId = setInterval(() => {
  //     this.loadReports(this.actualPage, this.filter, this.field);
  //   }, 50000); // Chama o método loadReports a cada 30 segundos
  // }

  private stopCallingLoadReports(): void {
    clearInterval(this.intervalId); // Para de chamar loadReports
  }

  fieldFilter(): void {
    this.field = this.typeFieldFilterSelected;
    this.filter = "";
  }

  private loadReports(
    page: PageEvent,
    name: string,
    field: string,
    showSpinner = true
  ): void {
    if (showSpinner) {
      this.spinner.show();
    }

    var uuidManager: string = storageX
      .whereKeyIs(STORAGE_KEY_UUID_MANAGER)
      .get();
    this.analyzeTripService
      .getAllAnalyzeReportManager(page, uuidManager, name, field)
      .subscribe(
        (t) => {
          this.analyzeReportManagersPage = t;
          this.analyzesManagers =
            new MatTableDataSource<AnalyzeReportManagerModel>(
              this.analyzeReportManagersPage.content
            );
          if (showSpinner) {
            this.spinner.hide();
          }
        },
        (error) => {
          console.log("Erro ao obter as analises do operador");
          if (showSpinner) {
            this.spinner.hide();
          }
        }
      );
  }

  applyFilter(): void {
    this.filterSearch$.next(this.filter);
  }

  private loadTableDefinitions(): void {
    this.tableColumns = [
      "packageNumber",
      "dateStart",
      "dateEnd",
      "operationalBase",
      "companyDestiny",
      "driverName",
      "plate",
      "OperadorName",
      "operatorHandling",
    ];

    if (
      this.permissionService.hasPermission(
        "ANALYZE_MINIO_FUNCIONALIDADE",
        this.permissions
      )
    ) {
      this.tableColumns.push("filePdfAnalytical", "filePdfSynthetic");
    }
  }

  exportReport(element): void {
    this.minioService.exportReport(element).subscribe();
  }

  openToTreatment(uuid: string) {
    this.router.navigate(["/analise-gestor/treatment/" + uuid]);
  }

  onChangePage(event: PageEvent): void {
    this.actualPage = event;
    this.loadReports(this.actualPage, this.filter, this.field);
  }

  private initialPage(): void {
    this.actualPage = new PageEvent();
    this.actualPage.pageIndex = 0;
    this.actualPage.pageSize = 10;
  }

  formatDate(dateString: string): string {
    // Converte a string de data para um objeto Date
    const date = new Date(dateString);

    // Formata a data usando o DatePipe
    return this.datePipe.transform(date, "yyyy-MM-dd HH:mm:ss");
  }
}
